var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditservices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8066)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8066",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0974 49.0232C23.4713 49.0235 21.8492 48.86 20.2558 48.5349C17.1829 47.9056 14.264 46.6773 11.6657 44.9202C7.80335 42.3129 4.77998 38.6415 2.96189 34.3508C2.34767 32.8975 1.87885 31.387 1.56229 29.8413C0.91153 26.6464 0.91153 23.3531 1.56229 20.1582C2.19163 17.0853 3.41991 14.1664 5.17703 11.568C7.78432 7.70569 11.4557 4.68232 15.7465 2.86424C17.1997 2.25002 18.7102 1.7812 20.2558 1.46463C23.4507 0.813874 26.744 0.813874 29.9389 1.46463C33.0119 2.09397 35.9308 3.32225 38.5291 5.07937C42.3915 7.68672 45.4148 11.3582 47.2329 15.649C47.8471 17.1022 48.316 18.6126 48.6326 20.1582C49.2834 23.3531 49.2834 26.6464 48.6326 29.8413C48.0033 32.9142 46.775 35.8331 45.0179 38.4314C42.4105 42.2938 38.739 45.3172 34.4482 47.1352C32.995 47.7495 31.4846 48.2183 29.9389 48.5349C28.3456 48.8599 26.7236 49.0235 25.0974 49.0232ZM7.26746 31.5199V35.0779H42.8461V31.5199H7.26746ZM25.0568 10.1728C24.1136 10.1739 23.2094 10.5491 22.5424 11.216C21.8754 11.8829 21.5002 12.7871 21.499 13.7303C21.5009 14.2131 21.5976 14.6909 21.7836 15.1365C14.758 16.5916 9.52039 22.5974 9.04647 29.741H41.0672C40.5932 22.5974 35.3555 16.5916 28.3299 15.1365C28.5157 14.6912 28.6124 14.2137 28.6144 13.7311C28.6135 12.7878 28.2384 11.8834 27.5714 11.2163C26.9045 10.5492 26.0001 10.174 25.0568 10.1728Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditservices);
export default __webpack_public_path__ + "static/media/Edit services.87aba3c164f04a82fb8836432fb42f8a.svg";
export { ForwardRef as ReactComponent };